
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
	import FoamBoxLeftSVG from '@/components/FoamBoxLeftSVG.vue';

	@Observer
	@Component({
		components: { FoamBoxLeftSVG }
	})
	export default class LeftFootSVG extends Vue {}
